import React, { useEffect } from 'react';
import { Container, CTA, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { useDispatch, useSelector, useStore } from 'react-redux';
import {  TrackingForm, useFaContent, useTrackingManager } from 'src/feature-app';
import { RenderController } from 'src/feature-app/Screen';
import { OneFormState, Steps } from 'src/types';

export function TheOriginalsThankYou() {
	const { formInfo } = useSelector((state: OneFormState) => state);
	const trackingManager = useTrackingManager();
	const dispatch = useDispatch();
	const getTrackingForm = (): TrackingForm => ({
		LeadID: undefined,
		FormFields: undefined,
	});
	const faContent = useFaContent();
	const campingSoldOut = faContent?.campingSoldOut ? faContent.campingSoldOut == 'true' : false;
	const link = faContent?.campingUrl ? faContent?.campingUrl : 'https://www.ballena-alegre.com';
	const store = useStore();
	const { formData }: OneFormState = store.getState();
	const { fields } = formData;console.log(fields);

	useEffect(() => {
		// Thank you page no es gestionado como un step pero sí lo haremos en la analítica. Por eso Modificamos formInfo después del submit y antes del RESET
		const screenIndexThankyou = formInfo?.numberOfScreens;

		dispatch({ type: 'SET_FORM_SUBMITTED', payload: true });
		dispatch({
			type: 'SET_FORM_INFO',
			payload: { step: { screenIndex: screenIndexThankyou, name: 'ThankYou' } },
		});

		trackingManager.trackFormSubmissionSuccessMessageLoad(
			{
				contentId: undefined,
			},
			getTrackingForm(),
		);
	}, []);

	const screen: Steps = {
		title: (
			<>
				<div style={{ textAlign: 'center', paddingTop: '42px'}}>
					<Container wrap="always">
						<Text bold>¡Ya estás inscrito!</Text>

						<div style={{ paddingTop: '32px'}}>
							<Text appearance={TokenTextAppearance.bigcopy100}>Pronto recibirás un correo electrónico de confirmación <Text bold>con el código QR para acceder a la concentración.</Text> ¡Guárdalo bien!</Text>
						</div>

						<div style={{ padding: '32px 0'}}>
							{campingSoldOut ? (
								<Container wrap="always">
									<Text appearance={TokenTextAppearance.bigcopy100}>El camping La Ballena Alegre está completo, ¡pero no te preocupes! Puedes RESERVAR TU PARCELA O BUNGALOW en los siguientes campings cercanos de la Asociación de Campings de Sant Pere Pescador:</Text>
									<Text appearance={TokenTextAppearance.bigcopy100}><CTA target="_blank" emphasis='tertiary' tag='a' href="https://www.campingaquarius.com">Camping Aquarius</CTA></Text>
									<Text appearance={TokenTextAppearance.bigcopy100}><CTA target="_blank" emphasis='tertiary' tag='a' href="https://lagaviota.com">Camping La Gaviota</CTA></Text>
									<Text appearance={TokenTextAppearance.bigcopy100}><CTA target="_blank" emphasis='tertiary' tag='a' href="https://www.laspalmeras.com">Camping Las Palmeras</CTA></Text>
									<Text appearance={TokenTextAppearance.bigcopy100}><CTA target="_blank" emphasis='tertiary' tag='a' href="https://www.campinglasdunas.com">Camping Las Dunas</CTA></Text>
								</Container>
							): (
								<Text  appearance={TokenTextAppearance.bigcopy100}>Puedes hacer la reserva de tu parcela o bungalow directamente <CTA target="_blank" emphasis='tertiary' tag='a' href={link}>desde la web del camping</CTA></Text>
							)}
						</div>

					</Container>
				</div>
				{fields.tengoVW == 'true' ? (
					<div style={{ textAlign: 'center', paddingTop: '42px'}}>
						<Container wrap="always">
							<Text bold >¿Todavía no eres un The Originals?</Text>
							<div style={{ padding: '32px 0'}}>
								<Text appearance={TokenTextAppearance.bigcopy100}>Únete a la comunidad de propietarios The Originals y disfruta de ventajas en la Concentración: fast track en la inscripción y ventajas y actividades exclusivas por ser un The originals.</Text>
							</div>
							<CTA target="_blank" emphasis='secondary' tag='a' href="https://www.theoriginals.es">Regístrate ahora</CTA>
						</Container>
					</div>
				) : null}
			</>
		),
		fields: <></>,
	};
	return <RenderController screenType="full-screen" title={screen.title} fields={screen.fields} key={555} avoidTrackFormStepLoad thankYouPage />;
}
